import * as React from 'react'
// libs
import styled from 'styled-components'
// components
import Grid from '@mui/material/Grid2'
import { Scrollbar as ScrollbarOrigin } from 'components/UI'
// context
import { StrategyActionsBLContext } from 'containers/StrategyActions/layers/BL'
// icons
import CloseIconOrigin from '@mui/icons-material/Close'
// themes
import { colors } from 'themes'
// view components
import Search from '../../../Search'
import Member from '../Member/index'
// utils
import { darken } from 'polished'

// styled
const ClearFilter = styled((props) => <Grid {...props} />)`
  color: ${colors.blue500};
  cursor: pointer;
  font-weight: bold;
  margin-top: 8px;

  &:hover {
    color: ${darken(0.1, colors.blue500)};

    svg {
      path {
        fill: ${darken(0.1, colors.blue500)};
      }
    }
  }
`

const Scrollbar = styled((props) => <ScrollbarOrigin {...props} />)`
  height: 420px;
  padding-right: 16px;
  width: 284px;
`

const Wrapper = styled((props) => <Grid {...props} />)`
  padding: 16px 0 16px 16px;

  > div:first-child {
    margin-right: 16px;
    width: unset;
  }
`

// types
interface Props {
  closePopup: () => void
  handleInputChange: () => void
}

const Filter: React.FC<Props> = ({ closePopup, handleInputChange }) => {
  const { handleSetUsersFilter, usersOrPositions } = React.useContext(StrategyActionsBLContext)

  const clearFilter = () => {
    handleSetUsersFilter([])
    closePopup()
  }

  return (
    <Wrapper container direction={'column'}>
      <Search name={'member'} handleInputChange={handleInputChange} />
      <ClearFilter container direction={'row'} alignItems={'center'} onClick={clearFilter}>
        <CloseIconOrigin htmlColor={colors.blue500} />
        <Grid>clear filter and show everyone</Grid>
      </ClearFilter>
      <Scrollbar>
        <Grid>
          <Grid container direction={'column'}>
            {usersOrPositions.map((member) => (
              <Member key={member.id} user={member} />
            ))}
          </Grid>
        </Grid>
      </Scrollbar>
    </Wrapper>
  )
}

export default Filter
